import { CUSTOMER_MODE } from "@montana/constants/customer-mode";
import { staticSettings } from "@montana/helpers/static-settings.helper";
import { createCancellableServiceFunction } from "./http";

export const getSearch = createCancellableServiceFunction((query: string, filterLanguage: string, customerType: CUSTOMER_MODE, marketId: string) => {
    return f => f(`${staticSettings.apiUrl}/api/search/contentAndProducts?searchQuery=${query}&language=${filterLanguage}&customerType=${customerType}&marketId=${marketId}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
});

export const searchAutoSuggestions = createCancellableServiceFunction((query: string, filterLanguage: string) => {

    return f => f(`${staticSettings.apiUrl}/api/search/autoSuggestion`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ searchQuery: query, filterLanguage }),
    })
});

export const searchCategories = createCancellableServiceFunction((query: string, filterLanguage: string, customerType: string) => {

    return f => f(`${staticSettings.apiUrl}/api/search/categories?searchQuery=${query}&filterLanguage=${filterLanguage}&customerType=${customerType}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
});
